import { format } from "date-fns";
import { ptBR } from "date-fns/locale";

import { IGamificationAuditEvent } from "@/@types/gamification-audit";

import {
  getActionColor,
  getActionLabel,
  getEventDescription,
  getUpdatedFields,
} from "./history.utils";

interface HistoryContentProps {
  events: IGamificationAuditEvent[];
}

function formatEventDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "-";
  return format(date, "dd/MM/yyyy 'às' HH:mm", { locale: ptBR });
}

export function HistoryContent({ events }: HistoryContentProps) {
  if (events.length === 0) {
    return (
      <div className="py-8 text-center text-gray-500">
        Nenhum registro de histórico encontrado para esta campanha.
      </div>
    );
  }

  return (
    <div className="max-h-[60vh] space-y-3 overflow-y-auto pr-1">
      {events.map((event) => {
        const updatedFields = getUpdatedFields(event);
        return (
          <div
            key={event.id}
            className="rounded-lg border p-4 transition-colors hover:bg-gray-50"
          >
            <div className="mb-2 flex items-center justify-between gap-2">
              <span
                className={`rounded-full px-2 py-1 text-xs font-medium ${getActionColor(
                  event.action,
                )}`}
              >
                {getActionLabel(event.action)}
              </span>
              <span className="text-sm text-gray-500">
                {formatEventDate(event.created_at)}
              </span>
            </div>

            <p className="mb-2 text-sm text-gray-700">
              {getEventDescription(event)}
            </p>

            {updatedFields.length > 0 && (
              <p className="mb-2 text-xs text-gray-500">
                <span className="font-medium">Campos alterados:</span>{" "}
                {updatedFields.join(", ")}
              </p>
            )}

            <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-gray-500">
              <div>
                <span className="font-medium">Responsável:</span> {event.email}
              </div>
              {event.ip && (
                <div>
                  <span className="font-medium">IP:</span> {event.ip}
                </div>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}
